import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function Terms() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8 text-center">
          <Building2 className="h-12 w-12 text-blue-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-gray-900">{t('termsTitle')}</h1>
          <p className="text-gray-600 mt-2">{t('lastUpdated')} {new Date().toLocaleDateString()}</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{t('agreementToTerms')}</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none space-y-6">
            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection1Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection1P1')}</p>
              <p className="text-gray-700 leading-relaxed">{t('termsSection1P2')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection2Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection2Intro')}</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>{t('termsSection2Li1')}</li>
                <li>{t('termsSection2Li2')}</li>
                <li>{t('termsSection2Li3')}</li>
                <li>{t('termsSection2Li4')}</li>
                <li>{t('termsSection2Li5')}</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection3Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection3Intro')}</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>{t('termsSection3Li1')}</li>
                <li>{t('termsSection3Li2')}</li>
                <li>{t('termsSection3Li3')}</li>
                <li>{t('termsSection3Li4')}</li>
                <li>{t('termsSection3Li5')}</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection4Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection4Intro')}</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>{t('termsSection4Li1')}</li>
                <li>{t('termsSection4Li2')}</li>
                <li>{t('termsSection4Li3')}</li>
                <li>{t('termsSection4Li4')}</li>
                <li>{t('termsSection4Li5')}</li>
                <li>{t('termsSection4Li6')}</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">{t('termsSection4P2')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection5Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection5Intro')}</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>{t('termsSection5Li1')}</li>
                <li>{t('termsSection5Li2')}</li>
                <li>{t('termsSection5Li3')}</li>
                <li>{t('termsSection5Li4')}</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection6Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection6P1')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection7Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection7Intro')}</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>{t('termsSection7Li1')}</li>
                <li>{t('termsSection7Li2')}</li>
                <li>{t('termsSection7Li3')}</li>
                <li>{t('termsSection7Li4')}</li>
                <li>{t('termsSection7Li5')}</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection8Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection8P1')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection9Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection9P1')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection10Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection10P1')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection11Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection11P1')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection12Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection12P1')}</p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-900">{t('termsSection13Title')}</h3>
              <p className="text-gray-700 leading-relaxed">{t('termsSection13Intro')}</p>
              <p className="text-gray-700 leading-relaxed">
                <strong>Email:</strong> noreply@sourcemygoods.com
              </p>
            </section>

            <div className="pt-6 border-t mt-8">
              <p className="text-sm text-gray-600">{t('termsFooterNote')}</p>
            </div>
          </CardContent>
        </Card>

        <div className="mt-8 text-center">
          <Link to="/register" className="text-blue-600 hover:text-blue-800 font-medium">
            {t('backToRegistration')}
          </Link>
        </div>
      </div>
    </div>
  );
}
